import { useState, useEffect } from "react";
import { useCustomizationStore } from "features/ManageWebpage/modules/Customizations/store/useCustomizationStore";
import { useWebpageSectionChange } from "features/ManageWebpage/modules/Customizations/store/useWebpageSectionChange";
import { CUSTOMIZATION_SECTIONKEYS } from "features/ManageWebpage/modules/Customizations/common/utils/Customization.constants";

export const useBrandLogo = () => {
  const sectionConfig = useCustomizationStore((state) => state.sectionConfig);
  const sectionValue =
    sectionConfig[CUSTOMIZATION_SECTIONKEYS.BRAND_LOGO]?.value;

  const [logoUrl, setLogoUrl] = useState(sectionValue || null);
  const { handleSectionChange } = useWebpageSectionChange();

  useEffect(() => {
    setLogoUrl(sectionValue || null);
  }, [sectionValue]);

  const handleUploadLogo = (url) => {
    setLogoUrl(url);
    const payload = {
      feature_key: CUSTOMIZATION_SECTIONKEYS.BRAND_LOGO,
      feature_value: url,
    };
    handleSectionChange({ payload });
  };

  const handleRemoveLogo = () => {
    setLogoUrl(null);
    const payload = {
      feature_key: CUSTOMIZATION_SECTIONKEYS.BRAND_LOGO,
      feature_value: null,
    };
    handleSectionChange({ payload });
  };

  return {
    logoUrl,
    handleUploadLogo,
    handleRemoveLogo,
  };
};
